import React from "react";
import { Page } from "../../common/components/Page";
import { LostUnitsCreate } from "./LostUnitsCreate";

export const LostUnitsCreatePage: React.FC = () => {
  return <Page content={LostUnitsCreate} title="Create Lost Units" />;
};
